import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { RecoilRoot } from 'recoil';
import { Home } from './views/Home';
import { LaunchPractitioner, LaunchPatient } from './views/Launcher';
import { SettingsProvider } from './components/SettingsContext';
import { FhirClientProvider } from './components/FhirClientContext';

import './custom.scss';
import './pdf.scss';

export default class App extends Component {
	static displayName = App.name;

	render() {
		return (
			<RecoilRoot>
				<SettingsProvider>
					<Switch>
						<Route path='/launch.html' component={LaunchPractitioner} />
						<Route path='/launch-patient.html' component={LaunchPatient} />

						<FhirClientProvider>
							<Route exact path='/' component={Home} />
							<Route path='/form/:formpath' component={Home} />
							<Route path='/:environmentpath/form/:formpath' component={Home} />
						</FhirClientProvider>
					</Switch>
				</SettingsProvider>
			</RecoilRoot>
		);
	}
}
